import { create } from 'zustand';
import Token from "./token.service";

interface LoginStatusState {
    userLoggedIn: boolean;
    setUserLoggedIn: (v: boolean) => void;
    reset: () => void;
};

export const useLoginStatusStore = create<LoginStatusState>((set) => ({
    userLoggedIn: Token.getUser() !== undefined,
    setUserLoggedIn: (v: boolean) => set(({ userLoggedIn: v })),
    reset: () => set({ userLoggedIn: false }),
}));

export function resetStores() {
    useLoginStatusStore.getState().reset();
}
